import api from '../../services/api';

class ComplianceService {
    consolidado(atendimentoId) {
        return api.get('/atendimentos/compliance/', {
            params: { atendimento_id: atendimentoId },
        });
    }
}

const complianceService = new ComplianceService();

export default complianceService;
